import CryptoJS from "crypto-js";

// Encrypt data and store it in localStorage
export const encryptData = (data) => {
  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    "your-secret-key" // Use a secure, secret key here
  ).toString();
  localStorage.setItem("otpData", encryptedData); // Store the encrypted data in localStorage
};

// Decrypt data from localStorage
export const decryptData = () => {
  const encryptedData = localStorage.getItem("otpData");
  if (!encryptedData) return null;

  const bytes = CryptoJS.AES.decrypt(encryptedData, "your-secret-key");
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  return decryptedData ? JSON.parse(decryptedData) : null;
};
